import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { FindUser } from '../../../../../find-user-page/find-user';
import { UserType } from '../../../../../../api/types/user/user-type';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';
import { CourseMetadataType } from '../../../../../../api/types/programs/course/course-metadata.type';
import { ProgramDetails } from '../../../../../../api/types/programs/program-details';
import { ProgramSelectCourses } from '../../componenets/program-select-courses';

interface AddStudentsDialogContentProps {
  selectedUsers: UserSummaryType[];
  addCourses: boolean;
  selectedCourses: CourseMetadataType[];
  combinedCourses: CourseMetadataType[];
  selectedYear: number | null;
  program: ProgramDetails;
  visible?: boolean;
  onSelectedUsersChange: (users: UserSummaryType[]) => void;
  onAddCoursesChange: (addCourses: boolean) => void;
  onSelectedCoursesChange: (courses: CourseMetadataType[]) => void;
  onApprove: (
    selectedUsers: UserSummaryType[],
    setLoading: (loading: boolean) => void,
  ) => Promise<void>;
  onHide: () => void;
}

export const AddStudentsDialogContent: React.FC<
  AddStudentsDialogContentProps
> = ({
  selectedUsers,
  addCourses,
  selectedCourses,
  combinedCourses,
  selectedYear,
  program,
  visible = true,
  onSelectedUsersChange,
  onAddCoursesChange,
  onSelectedCoursesChange,
  onApprove,
  onHide,
}) => {
  const [loading, setLoading] = useState(false);
  const isSubmittingRef = useRef(false);

  const handleApprove = async () => {
    // Ref blocks same-tick double clicks before React re-renders `loading`.
    if (isSubmittingRef.current || loading) return;
    isSubmittingRef.current = true;
    try {
      await onApprove(selectedUsers, setLoading);
    } finally {
      isSubmittingRef.current = false;
    }
  };

  // Filter courses based on selected year when checkbox is active
  const getCoursesToDisplay = (): CourseMetadataType[] => {
    // If dialog is not visible, return empty array to prevent flash
    if (!visible) {
      return [];
    }

    if (!addCourses || selectedYear === null) {
      return combinedCourses;
    }

    // Find courses for the selected year only
    const yearData = program.years?.find((year) => year.year === selectedYear);
    const yearCourses = yearData?.courses || [];

    return yearCourses;
  };

  return (
    <>
      <FindUser
        onChange={onSelectedUsersChange}
        role={UserType.STUDENT}
        onApprove={onApprove}
        displayApprove={false}
      />
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Checkbox
          checked={addCourses}
          onChange={(e) => onAddCoursesChange(e.checked || false)}
        />
        <label style={{ marginRight: '4px' }}>
          הוספת הסטודנטים לקורס הקיימים
        </label>
      </div>
      {addCourses && (
        <ProgramSelectCourses
          onSelectChange={onSelectedCoursesChange}
          courses={getCoursesToDisplay()}
        />
      )}
      <div
        style={{
          marginTop: '8px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
        }}
      >
        <Button
          style={{ height: '30px' }}
          label={'ביטול'}
          outlined={true}
          onClick={onHide}
          disabled={loading}
        />
        <div style={{ marginRight: '8px' }} />
        <Button
          onClick={handleApprove}
          style={{ height: '30px' }}
          label={'אישור'}
          loading={loading}
          disabled={loading}
        />
      </div>
    </>
  );
};
